import { track } from 'src/tracking/trackingService';

interface AppointmentModel {
  get: (key: string) => unknown;
  belongsToGroup: () => boolean;
}

type QuoteTrackingPayload = {
  clientType: 'walk_in' | 'new' | 'returning';
  hasPackage: boolean;
  localCurrency: string;
  accessedFrom: string;
  services: string[];
  serviceOriginalPricesLocalCurrency: number[];
  numberOfEmployees: number;
  userId: string;
};

export function trackCreateQuoteClicked(models: AppointmentModel[]): void {
  const uniqueEmployeeIds = new Set(models.map((m) => m.get('employeeId')).filter(Boolean));
  const hasWalkIn = models.some((m) => m.get('walkIn') === true);
  const hasFirstTime = models.some((m) => m.get('firstTimeCustomer') === true);
  const clientType = hasWalkIn ? 'walk_in' : hasFirstTime ? 'new' : 'returning';
  const employeeId = App.config.get('currentEmployeeId');
  const userId = typeof employeeId === 'number' ? String(employeeId) : '';

  const payload: QuoteTrackingPayload = {
    accessedFrom: 'appointment',
    clientType: clientType,
    hasPackage: models.some((m) => m.belongsToGroup()),
    localCurrency: App.config.get('venue').currencyCode,
    services: models.map((m) => m.get('offerName')).filter(Boolean) as string[],
    serviceOriginalPricesLocalCurrency: models
      .map((m) => m.get('amount'))
      .filter((v) => v != null) as number[],
    numberOfEmployees: uniqueEmployeeIds.size,
    userId,
  };

  track('payments.quote_flow.appointment.create_quote.clicked', {
    ...payload,
    screen: 'quote/cart',
  });
}

export function trackViewQuoteClicked(quoteId: number): void {
  const employeeId = App.config.get('currentEmployeeId');
  const userId = typeof employeeId === 'number' ? String(employeeId) : '';

  track('payments.quote_flow.appointment.view_quote.clicked', {
    quoteId,
    localCurrency: App.config.get('venue').currencyCode,
    userId,
  });
}
